import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";

function MarketDataModal({ show, handleClose, onSave, data }) {
  const [formData, setFormData] = useState({
    challan_no: "",
    amount: "",
    total_of_coupon: "",
    collection_date: "",
  });
  const [loading, setLoading] = useState(false);
  const isEditMode = !!data;

  const API_URL = process.env.REACT_APP_SUPER_ADMIN_API_URL;
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (data) {
      setFormData(data);
    } else {
      setFormData({
        challan_no: "",
        amount: "",
        total_of_coupon: "",
        collection_date: new Date().toISOString().split("T")[0],
      });
    }
  }, [data]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const endpoint = isEditMode
      ? "/update-market-data.php"
      : "/add-market-data.php";
    const payload = isEditMode ? { ...formData, id: data.id } : formData;

    try {
      const response = await axios.post(`${API_URL}${endpoint}`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.data.success) {
        toast.success(`Data ${isEditMode ? "updated" : "added"} successfully!`);
        onSave();
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error("An error occurred.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{isEditMode ? "Edit" : "Add"} Market Data</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Challan No</Form.Label>
            <Form.Control
              type="text"
              name="challan_no"
              value={formData.challan_no}
              onChange={handleChange}
              required
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Amount</Form.Label>
            <Form.Control
              type="number"
              name="amount"
              value={formData.amount}
              onChange={handleChange}
              required
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Total Coupons</Form.Label>
            <Form.Control
              type="number"
              name="total_of_coupon"
              value={formData.total_of_coupon}
              onChange={handleChange}
              required
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Collection Date</Form.Label>
            <Form.Control
              type="date"
              name="collection_date"
              value={formData.collection_date}
              onChange={handleChange}
              required
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" type="submit" disabled={loading}>
            {loading ? <Spinner size="sm" /> : "Save"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export default MarketDataModal;
